/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

import Routes from './core/routes';
import history from './core/utils/history';
import debug from './core/utils/debug';
import SpaceBackground from './components/SpaceBackground';
import AnalyticsProvider from './components/AnalyticsProvider';

import './styles/style.css';
/** Actions: The necessary actions for dispatching our bootstrap values */
import { setVersion } from './core/global/globalActions';

/** The version of the app but not displayed yet */
import pack from '../package.json';

/** configureStore */
import configureStore from './core/store';

// Get Sentry error wrapper
const ErrorWrapper = debug.getWrapper();

const globalStore = configureStore({});
const { store, persistor } = globalStore;

const VERSION = pack.version;

store.dispatch(setVersion(VERSION));

ReactDOM.render(
    <ErrorWrapper>
        <HelmetProvider>
            <SpaceBackground />
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <Router history={history} basename="/">
                        <AnalyticsProvider>
                            <Routes persistor={persistor} />
                        </AnalyticsProvider>
                    </Router>
                </PersistGate>
            </Provider>
        </HelmetProvider>
    </ErrorWrapper>,
    document.getElementById('root'),
);
